import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion"
import { Col, Row } from "react-bootstrap"
import styled from "styled-components"

export default function Accordions({ items, fullWidth }) {
  return (
    <AccordionStyling>
      <Accordion allowZeroExpanded>
        <Row>
          {items.map(item => (
            <Col xs="12" md={fullWidth ? "12" : "6"}>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <Title>
                      {item.icon}
                      <span>{item.title}</span>
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        style={{ float: "right" }}
                      />
                    </Title>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>{item.desc}</p>
                </AccordionItemPanel>
              </AccordionItem>
            </Col>
          ))}
        </Row>
      </Accordion>
    </AccordionStyling>
  )
}

function AccordionStyling(props) {
  return <Style>{props.children}</Style>
}

const Style = styled.div`
  .accordion__button {
    position: relative;
    border: 1px solid #ddd;
    padding: 17px 17px 17px 17px;
    font-size: 17px;
    color: #263045;
    &:hover {
      cursor: pointer;
      background-color: #0e2b89;
      color: #fff;
      transition: ease-in-out 0.3s;
      svg {
        color: #ffffff;
      }
    }
    svg {
      color: #0e2b89;
      margin-top: 4px;
    }
  }
  .accordion__panel {
    padding: 14px 20px;
    transition: ease-in-out 0.3s;
  }
  .accordion__item {
    margin-bottom: 15px;
  }
  .accordion.style2 {
    .accordion__button {
      padding-bottom: 15px;
      border: 0;
      padding: 0 15px 15px 35px;
      font-weight: 600;
      font-size: 16px;
      &::after {
        left: 0;
        top: 0;
        right: auto;
        content: "\f056";
        font-family: "FontAwesome";
      }
      &:hover {
        background-color: transparent;
        color: #263045;
        &::after {
          color: #263045;
        }
      }
    }
    .accordion__item {
      border-bottom: 1px solid #ddd;
    }
  }
`

const Title = styled.div`
  margin-left: 30px;
  svg {
    margin-left: -30px;
  }
  span {
    padding-left: 10px;
    padding-right: 20px;
  }
`
